import React from 'react';

import usePage from '@dashboard/hooks/usePage';
import { hasRecurringPrice } from '@dashboard/services/getBillingModel';

import Divider from '@dashboard/components/Divider';

import PageEditView from '../../components/PageEditView';
import { editorSection } from '../../pageEditTabs';
import FilesForm from '../PageSettings/components/FilesForm';
import ProductDiscountsForm from '../PageSettings/components/ProductDiscountsForm';

import ProductDescriptionForm from './components/ProductDescriptionForm';
import ProductDetailsForm from './components/ProductDetailsForm';
import ProductFilesForm from './components/ProductFilesForm';
import ProductInventoryForm from './components/ProductInventoryForm';
import ProductLicenseKeysForm from './components/ProductLicenseKeysForm';
import ProductMediaForm from './components/ProductMediaForm';
import ProductVariantsForm from './components/ProductVariantsForm';

export const getProductSections = ({ page, seller }) => {
  const context = { page, seller };
  const section = path => editorSection('product', path, context);

  return [
    {
      ...section('/details'),
      component: <ProductDetailsForm product={page.product} />,
      description: 'Set your product title and pricing options.',
    },
    {
      ...section('/description'),
      component: <ProductDescriptionForm />,
      description: 'Add text, images, FAQs, and more to describe your product.',
    },
    {
      ...section('/image-gallery'),
      component: <ProductMediaForm />,
      description: 'Add images to showcase your product.',
    },
    {
      ...section('/variants'),
      component: <ProductVariantsForm />,
      description: 'Offer options for customers to choose from.',
      helpUrl: '/docs/articles/guide-to-product-variants',
    },
    {
      ...section('/file-downloads'),
      component: (
        <>
          <ProductFilesForm />

          {hasRecurringPrice(page.product) && (
            <>
              <Divider className="my-8" />
              <FilesForm />
            </>
          )}
        </>
      ),
      description: 'Upload files customers can download after purchase.',
      helpUrl: '/docs/articles/how-to-sell-digital-downloads',
    },
    {
      ...section('/inventory'),
      description: 'Limit how many times this product can be purchased.',
      helpUrl: '/docs/articles/inventory-stock',
      component: <ProductInventoryForm />,
    },
    {
      ...section('/license-keys'),
      component: <ProductLicenseKeysForm />,
      description: 'Verify purchases in your application and manage access.',
      helpUrl: '/docs/articles/license-keys',
    },
    {
      ...section('/bulk-discounts'),
      description:
        'Offer discounts based on the number of items purchased. Applies to one-time payment prices only.',
      helpUrl: '/docs/articles/bulk-discounts',
      component: <ProductDiscountsForm />,
    },
  ].filter(tab => tab.isVisible(context));
};

const PageProduct = () => {
  const { page } = usePage();

  return <PageEditView tabs={getProductSections({ page })} />;
};

export default PageProduct;
